export const informationData = {
  title: "Praktické informace",
  introduction: "Akce je zařazena do seriálu IVV, razítko získáte na prezenci.",
  informationItems: [
    {
      subtitle: "Ubytování",
      descriptions: [
        "Ubytování na lůžku organizátor nezajišťuje.",
        "Možnosti ubytování v hotelech a penzionech v Hlučíně jsou omezené. V okolí Hlučína - v Ostravě a na Opavsku - je dostatečné množství ubytovacích kapacit.",
        "Tipy na ubytování najdete zde:",
      ],
      descriptionLink:
        "https://docs.google.com/spreadsheets/d/1ltzGKdnnD1vPQENz3P3VSG9q_nAZh0z6/edit?gid=542793138#gid=542793138",
      descriptionLinkText: "Odkaz na tipy na ubytování",
    },
    {
      subtitle: "Ubytování tělocvična",
      descriptions: [
        "Pro zájemce o ubytování ve vlastním spacáku a na karimatce je zajištěno 50 míst v tělocvičně ZŠ Hlučín - Tyršova.",
        "Zájem o tento typ ubytování vyznačte v elektronické přihlášce na sraz.",
        "Volná místa budou obsazována pouze do zaplnění kapacity.",
      ],
    },
    {
      subtitle: "Ubytování pro oddíly TOM",
      descriptions: [
        "U oddílů TOM respektujeme, že nejsou schopny přihlásit jmenovitě své členy v určeném termínu. Prosíme oddíly TOM, aby na e-mail cmoudik@cmoudik.cz (p. Rostislav Kašovský) napsali svůj zájem o ubytování a předpokládaný počet účastníků TOM.",
        "Pro účastníky z řad Turistických oddílů mládeže máme vyčleněno 300 míst v tělocvičně a třídách (nocleh ve vlastním spacáku a karimatce) v ZŠ Hlučín - Rovniny.",
      ],
    },
    {
      subtitle: "Zimní táboření",
      descriptions: [
        "Další možností je přespání je ve vlastním stanu.",
        "Zimní táboření bude připraveno u jedné z pevností - u bunkru Jaroš v Darkovičkách.",
        "Zájemci se rovněž přihlásí přes elektronický přihlašovací systém.",
      ],
    },
    {
      subtitle: "Stravování",
      descriptions: [
        "Organizátor nezajišťuje stravování. Využijte možnost stravování v hlučínských restauracích, popř. na trase v okolních obcích.",
        "Během turistického srazu proběhnou v Hlučíně akce Svařák Fest (sobota), a Farmářské trhy (neděle), na kterých bude možno zakoupit občerstvení.",
        "Během nedělních turistických pochodů budou na kontrolním místě u pevnosti Jaroš v Darkovičkách zajištěny buřty k opékání.",
      ],
    },
    {
      subtitle: "Ceník",
      descriptions: ["Jednodenní účastníci se budou registrovat na místě."],
      descriptionLink: "/files/cenik-PP-2025.pdf",
      descriptionLinkText: "Ceník Za posledním puchýřem 2025",
    },
    {
      subtitle: "Bankovní údaje",
      descriptions: [
        "Bankovní účet: 131-3414290267/0100",
        "IBAN: CZ53 0100 0001 3134 1429 0267",
        "BIC (SWIFT) kod: KOMBCZPPXXX",
      ],
    },
    {
      subtitle: "Přihlášení vícedenních účastníků",
      descriptions: [
        "Přihlašování bude probíhat výhradně prostřednictvím elektronické přihlášky.",
        "Přihlašovat se můžete do 15.9.2025. Na pozdější přihlášky nebudeme brát zřetel.",
      ],
    },
    {
      subtitle: "Prezence účastníků turistického srazu",
      descriptions: ["Kulturní dům Hlučín", "Ostravská 124/18, 74801 Hlučín"],
      descriptionLink: "https://mapy.cz/s/potobunega",
      descriptionLinkText: "Odkaz na Kulturní dům Hlučín",
    },
    {
      subtitle: "Dopravní obslužnost",
      descriptions: [
        "doprava autobusem - z Ostravy do Hlučína jezdí linkové autobusy i autobusy MHD",
        "doprava vlakem - na linkách S11 a S12 probíhá po loňských povodních nepřetržitá výluka traťové koleje v úseku Opava východ - Kravaře ve Slezsku - Hlučín/Chuchelná. Vlaky jsou nahrazeny autobusy náhradní dopravy dle výlukového jízdního řádu.Mezi Ostravou a Hlučínem přímé vlakové spojení neexistuje, vlak z Ostravy s cílovou stanicí Opava zastavuje v Děhylově, který je od Hlučína vzdálený 3 km.",
      ],
    },
    {
      subtitle: "Storno přihlášky",
      descriptions: [
        "Při stornu přihlášky do 15. 9. 2025 vracíme zaplacenou částku po odečtení manipulačního poplatku ve výši 50 Kč.",
        "Účastník má možnost za sebe poslat náhradníka, ale musí o tom informovat pořadatele. Při pozdějším stornování účasti již peníze nevracíme, protože již nebude možné stornovat objednané služby.",
        "Žádost o stornování přihlášky můžete zaslat mailem na p. Petra Minku, e-mail: mphav@seznam.cz",
      ],
    },
    {
      subtitle: "GDPR",
      descriptions: [
        "Podáním přihlášky účastníci poskytují v souladu se směrnicí GDPR souhlas s využitím uvedených údajů za účelem organizačního zajištění akce 'Za posledním puchýřem 2025'",
        "Berete též na vědomí, že během akce bude pořizována fotodokumentace pro účely vyúčtování a propagace KČT a zapojených partnerů.",
        "Zpracovatelem a správcem údajů je KČT, oblast Moravskoslezská.",
      ],
    },
  ],
};
